import {
  AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentRef, HostListener, Inject, OnDestroy,
  OnInit, PLATFORM_ID, ViewChild, ViewContainerRef
} from '@angular/core';
import {
  activeFiltersPage, selectBanner, selectCitiesList,
  selectCountActiveFilters, selectCurrentCity,
  selectFounds, selectFoundsFiltersPage,
  selectPageEnd, selectPageLoadingState, selectPreparatSeoData, selectReferences, selectSeoAnalogsForListPage,
  selectSeoData, selectSeoEditorState, selectSeoFaqForListPage,
  selectSeoTextForThirdLvlListPage, selectTableWithPricesForListPage,
  selectTarget,
  selecttotalGoodsNumber, selectTradeTitleForListPage
} from '@selectors';
import { forkJoin, Observable, Subject } from 'rxjs';
import {
  AddPageCountLoadDataAction, ClearFoundActionSuccess, PrivatePageChangeCurrentBlock,
  PrivatePageExceptionReturnBtn, ResetFilterBufferAction, ResetPageCountLoadDataAction,
  ResetPageStateAction,
  setSelectedCategoryAction, SetTargetSuccess, ShowMoreLoadDataAction, TogglePreparatPharmacyProducts
} from '@actions';
import { ActivatedRoute, Data, NavigationEnd, Params, Router, RouterEvent } from '@angular/router';
import { AppState } from '@appStates';
import { ECurrentOrderBlock, ListLazyComponents, Pages } from '@enums';
import { select, Store } from '@ngrx/store';
import {
  debounceTime, filter, map, switchMap,
  take, takeUntil, tap, withLatestFrom
} from 'rxjs/operators';
import {
  BzProduct, IBanner, ICity, IEditor, IFaqResponse, IPreparatPageResponse, IPreparatPharmacy, ISeoData,
  ITableCatalogProductsResponse,
  IToSearchWithCategory, ITradeGoodsResponse,
  ParamsPageSearch
} from '@interfaces';
import { LazyLoadComponentsService } from 'src/app/lazy-load-components-ui/factories/lazy-load-components.service';
import { LocalizationService, ScreenDetectedService, SeoService } from '@core/services';
import { getPrevRouteState } from 'src/app/store/selectors/navigate.selectors';
import { RouterStateUrl } from 'src/app/store/router/custom-serializer';
import { isPlatformBrowser, PlatformLocation } from '@angular/common';
import { ApplicationRoutingService } from '@application-routing';
import { ConcatParamsService } from '../../core/services/helpers/help-service-for-search-page/concat-params.service';
import { AddFilterToParamsUrlService } from '../../core/services/helpers/help-service-for-search-page/add-filter-to-params-url.service';
import { DetectedSwitchPageService } from '../../core/services/helpers/help-service-for-search-page/detected-switch-page.service';
import { StartForNewDataPageService } from 'src/app/core/services/helpers/help-service-for-search-page/start-for-new-data-page.service';
import { TranslocoService } from '@jsverse/transloco';
import { ScrollPositionLocalStorageService } from '../../core/services/storage.services/scroll-position-local-storage.service';
import { JsonLDServiceService } from 'src/app/core/services/seo.services/json-ldservice.service';
import { getPageNumForTitle } from 'src/app/shared/utils';
import { RestUrlService, TypeUrl } from 'src/app/core/services/api.services/settings/rest-url.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('filters', { read: ViewContainerRef }) public filters: ViewContainerRef;
  @ViewChild('p') public p: any; // paginator template

  public selectCurrentCity: Observable<string> = this.store.pipe(select(selectCurrentCity));
  public countActiveFilters: Observable<number> = this.store.pipe(select(selectCountActiveFilters));
  public titleForListPage: Observable<string> = this.store.pipe(select(selectTradeTitleForListPage));
  public seoAnalogListProducts: Observable<BzProduct[] | null> = this.store.pipe(select(selectSeoAnalogsForListPage));
  public cities: Observable<ICity[]> = this.store.pipe(select(selectCitiesList), filter(value => !!value));
  public loading: Observable<boolean> = this.store.pipe(select(selectPageLoadingState));
  public searchTarget: Observable<string> = this.store.pipe(select(selectTarget));

  public pages: Observable<number>;
  public preparatBloks: Observable<BzProduct[]>;
  public references: Observable<IToSearchWithCategory[]>;
  public totalGoodsNumber: Observable<number>;
  public seoTextUnderPagination: Observable<string | null>;
  public seoTableWithPrices: Observable<ITableCatalogProductsResponse | null>;
  public seoFaqForTradeNameListPage: Observable<ITradeGoodsResponse | null>;
  public seoEditor: Observable<IEditor | null>;
  public banner: Observable<IBanner | null>;
  public preparatSeoData: Observable<IPreparatPageResponse | null>;

  public isSearchPage = false;
  public isSearchTradeName = false;
  public showFullSeoText = true;

  public seoData: ISeoData;
  public params: ParamsPageSearch;
  public imgPath: string;
  public bannerImages: string;

  public searchByEnterValue: string | undefined;
  public currentLang: string;
  public isPreparatPage = false;
  public currentTownForPreparatPage: string;

  private activeFiltersNum: number;
  private selectedReference: IToSearchWithCategory;
  private bufferPage: number;
  private url: string;
  private scrollPosition = 0;
  private componentDestroyer: Subject<void> = new Subject();

  // tslint:disable-next-line:typedef
  @HostListener('window:scroll', ['$event']) onWindowScroll(e: any) {
    if (this.screen.isMobile()) {
      this.scrollPosition = e.target.scrollingElement.scrollTop;
    }
  }

  @HostListener('window:popstate', ['$event'])
  public onPopState(): void {
    if (this.selectedReference) {
      this.selectedReference = null;
      let prevPattern: RouterStateUrl;
      this.store.pipe(take(1), select(getPrevRouteState)).subscribe((prev: RouterStateUrl) => prevPattern = prev);
      this.store.dispatch(ClearFoundActionSuccess());
      this.store.dispatch(SetTargetSuccess({
        target: prevPattern.queryParams.pattern, life: '', option: {
          id: 6,
          name: prevPattern.queryParams.pattern,
          url: prevPattern.queryParams.pattern,
          info: 'null'
        },
        p: false,
        anyParams: this.helperParamsService.concat(null, this.params)
      }));
      this.store.dispatch(ResetFilterBufferAction({ status: true }));
    }
    if (this.activeFiltersNum > 0) {
      window.location.reload();
    }

    this.resetCategoryPage();
  }

  constructor(
    // tslint:disable-next-line:ban-types
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly translocoService: TranslocoService,
    private readonly helperParamsService: ConcatParamsService,
    private readonly helperFilterService: AddFilterToParamsUrlService,
    private readonly helperDetectedPageService: DetectedSwitchPageService,
    private readonly helperStartForNewData: StartForNewDataPageService,
    private readonly scrollPS: ScrollPositionLocalStorageService,
    private readonly seo: SeoService,
    private readonly locale: LocalizationService,
    private readonly platform: PlatformLocation,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly screen: ScreenDetectedService,
    private readonly lazy: LazyLoadComponentsService,
    private readonly store: Store<AppState>,
    private readonly appRoutingService: ApplicationRoutingService,
    private readonly cdr: ChangeDetectorRef,
    private readonly jsonLDService: JsonLDServiceService,
    private readonly restUrlService: RestUrlService
  ) {
    this.bannerImages = this.restUrlService.getUrl(TypeUrl.img) + '/ad/';
    this.imgPath = this.restUrlService.getUrl(TypeUrl.img) + '/';
    this.activatedRoute.data.pipe(
      takeUntil(this.componentDestroyer)
    ).subscribe((data: Data) => {
      if (typeof data[0] !== 'boolean') {
        const { isPreparatPage, town }: { isPreparatPage: boolean, town: string } = data[0];
        this.isPreparatPage = isPreparatPage ? isPreparatPage : false;
        this.currentTownForPreparatPage = town ? town : undefined;
      }
      this.seo.getTegRobots(Pages.category);
      this.seo.updateLinkHreflang();
      this.getFoundBlocks();
      this.getParamsRequest();
    });
  }

  ngOnInit(): void {
    this.currentLang = this.locale.getLang();

    this.activatedRoute.queryParams.pipe(
      takeUntil(this.componentDestroyer)
    ).subscribe((params: ParamsPageSearch) => {
      if (!this.helperDetectedPageService.isCategoryPage()) {
        this.params = params;
        if (this.platform.pathname.includes('/search/')) {
          this.isSearchPage = true;
          this.isSearchTradeName = false;
          this.searchByEnterValue = params.pattern;
        } else if (this.platform.pathname.includes('/list/')) {
          this.isSearchPage = true;
          this.isSearchTradeName = true;
          this.searchByEnterValue = undefined;
        } else {
          this.isSearchPage = false;
          this.isSearchTradeName = false;
          this.searchByEnterValue = undefined;
        }
      }
    });

    // если параметров больше дэфолтного набора, значит фильтр какой-либо применен и можно сестить каноникал

    this.router.events.pipe(
      takeUntil(this.componentDestroyer)
    ).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.seo.getTegRobots(Pages.category);
        this.seo.updateLinkHreflang();
        if (this.selectedReference) {
          this.store.dispatch(SetTargetSuccess({
            target: this.params.pattern, life: '', option: {
              id: this.selectedReference.sectionId,
              name: null,
              url: this.selectedReference.url,
              info: this.selectedReference.info
            },
            p: false,
            anyParams: this.helperParamsService
              .concat(null, this.params)
          }));
        }
      }
    });

    if (isPlatformBrowser(this.platformId)) {
      if (this.screen.isDesktop()) {
        window.addEventListener('scroll', this.scroll, true);
      }
    }

    this.screen.resizeObservable$
      .pipe(takeUntil(this.componentDestroyer))
      .subscribe(() => {
        if (window.innerWidth < 1245) {
          this.lazy.clearContainer(this.filters);
        } else if (!this.filters.length) {
          this.addedFiltersBlock();
        }
      });

    this.countActiveFilters.pipe(
      takeUntil(this.componentDestroyer)
    ).subscribe((count: number) => this.activeFiltersNum = count);

    // this.ngZone.runOutsideAngular(() => {
    //   setTimeout(() => {
    //     this.showFullSeoText = false;
    //     this.cdr.detectChanges();
    //   }, 5000);
    // });
  }

  public scroll = (event: Event): void => {
    this.scrollPosition = (event.target as HTMLElement).scrollTop;
    if ((event.target as HTMLElement).scrollTop === 0) {
      this.scrollPS.scrollPosition = '0';
    }
  }

  public ngAfterViewInit(): void {
    this.getDataPage();
    // восстановление позиции скролла и сворачивание сео текста
    if (isPlatformBrowser(this.platformId)) {
      this.scrollPositionSearchPage(Number(this.scrollPS.scrollPosition));
    }
    this.cdr.detectChanges();
  }

  public getDataPage(): void {
    if (!this.helperDetectedPageService.isCategoryPage()) { this.getFounds(); }
    if (window.innerWidth > 1245) { this.addedFiltersBlock(); }
  }

  public toChangeRegion(): void {
    if (!this.screen.isDesktop()) {
      this.store.dispatch(PrivatePageChangeCurrentBlock({ currentBlock: ECurrentOrderBlock.location }));
      this.store.dispatch(PrivatePageExceptionReturnBtn({ exception: this.router.routerState.snapshot.url }));
      this.appRoutingService.navigate(ListLazyComponents.private, this.router.routerState.snapshot.url);
    } else {
      this.appRoutingService.navigate(ListLazyComponents.location, this.router.routerState.snapshot.url);
    }
  }

  public toSearchFromCrumbs(item: IToSearchWithCategory): void {
    this.selectedReference = item;
    this.resetCategoryPage();
  }

  public resetCategoryPage(): void {
    this.store.dispatch(ClearFoundActionSuccess());
    this.store.dispatch(ResetPageCountLoadDataAction());
  }

  public getLinkFromCrumb(crumb: IToSearchWithCategory): string {
    if (crumb.info === '1' || crumb.info === '2') {
      return this.locale.getRouterLinkApp(`catalog/${crumb.url}`);
    } else if (crumb.info === '3') {
      return this.locale.getRouterLinkApp(`category/${crumb.url}`);
    } else if (crumb.info === 'trade') {
      return this.locale.getRouterLinkApp(`list/${crumb.url}`);
    }
  }

  public toCatalog(): void {
    this.store.dispatch(setSelectedCategoryAction({ category: null }));
    this.router.navigate(this.locale.getReturnParamsLang(['catalog']));
  }

  public getHomePageLink(): string {
    return this.locale.getLang() === 'ru' ? '/' : '/ua';
  }

  public getFounds(additionalLoading: boolean = false, anyParams?: any, pages?: [number, number]): void {
    if (additionalLoading) {
      this.getParamsRequest();
      if (pages) {
        this.store.dispatch(AddPageCountLoadDataAction({ pages }));
      } else {
        this.store.dispatch(AddPageCountLoadDataAction({}));
      }
    }

    this.helperStartForNewData.startDispatchAction(additionalLoading, this.url, this.params, anyParams, this.currentTownForPreparatPage);
  }

  public showMore(): void {
    if (!this.bufferPage) { this.bufferPage = this.p.getCurrent(); }

    this.store.dispatch(ShowMoreLoadDataAction({ load: true }));
    this.getFounds(true);
  }

  public resetPageScroll(): void {
    this.scrollPS.scrollPosition = '0';
    this.scrollPositionSearchPage(0, true);
    this.scrollPosition = null;
  }

  public pageChange(value?: number): void {
    this.resetPageScroll();

    this.store.dispatch(ShowMoreLoadDataAction({ load: false }));

    if (this.bufferPage === value) {
      this.getFounds(true, {}, [value, value]);
    }

    this.bufferPage = null;

  }

  public returnLinkPagination(e: number): string {
    const rout: 'category' | 'search' | 'list' | 'preparat' =
      this.helperDetectedPageService.getDetectPage(this.isSearchTradeName, this.isPreparatPage);
    let url: string;
    this.activatedRoute.params.pipe(take(1)).subscribe((params: Params) => {
      if (params.url) {
        if (this.isPreparatPage) {
          url = `${params.url}/${this.currentTownForPreparatPage}`;
        } else {
          url = params.url;
        }
      }
    });
    if (this.locale.getLang() === 'ru') {
      if (e > 1) {
        return `/${rout}/${url}/page${e}`;
      } else {
        return `/${rout}/${url}`;
      }
    }
    if (this.locale.getLang() === 'ua') {
      if (e > 1) {
        return `/ua/${rout}/${url}/page${e}`;
      } else {
        return `/ua/${rout}/${url}`;
      }
    }
  }

  public addFilterToParamsUrl(data: Map<string, Set<number>> | any[]): void {
    const [addParams, queryParams] = this.helperFilterService.add(
      data,
      this.params,
      this.helperDetectedPageService.isCategoryPage(),
      this.isSearchTradeName
    );

    if (Object.keys(addParams).length === 0) {
      this.seo.deleteCanonical();
    }

    this.scrollPS.scrollPosition = '0';
    this.resetCategoryPage();

    if (this.isSearchTradeName) {
      this.router.navigate(this.locale.getReturnParamsLang(['list', this.url]), { queryParams: addParams });
    } else {
      if (this.isPreparatPage) {
        this.router.navigate(this.locale.getReturnParamsLang([
          'preparat', this.params.pattern, this.currentTownForPreparatPage
        ]), { queryParams: addParams });
      } else {
        this.router.navigate(this.locale.getReturnParamsLang([
          this.helperDetectedPageService.getDetectPage(false, false), this.url
        ]), { queryParams });
      }
    }

    this.activatedRoute.params.pipe(take(1)).subscribe((params: Params) => {
      if (!params.page) {
        this.helperStartForNewData.startDispatchAction(true, this.url, this.params, addParams, this.currentTownForPreparatPage);
      }
    });
  }

  public trackById(_: unknown, element: { id: number }): number {
    return element.id;
  }

  public getRouterLinkToPreparat(): string {
    return this.locale.getRouterLinkApp('preparat');
  }

  public switcherFilter(): void {
    if (this.filters.length) {
      this.lazy.clearContainer(this.filters);
    } else {
      this.addedFiltersBlock();
    }
  }

  public getFoundBlocks(): void {
    this.seoTextUnderPagination = this.store.pipe(select(selectSeoTextForThirdLvlListPage));
    this.seoTableWithPrices = this.store.pipe(select(selectTableWithPricesForListPage));
    this.seoFaqForTradeNameListPage = this.store.pipe(select(selectSeoFaqForListPage));
    this.seoEditor = this.store.pipe(select(selectSeoEditorState));
    this.banner = this.store.pipe(select(selectBanner));
    this.preparatSeoData = this.store.pipe(select(selectPreparatSeoData));
    this.preparatBloks = this.store.pipe(select(selectFounds));
    this.totalGoodsNumber = this.store.pipe(select(selecttotalGoodsNumber));
    this.references = this.store.pipe(select(selectReferences));
    this.pages = this.store.pipe(select(selectPageEnd));
    this.store.pipe(
      select(selectSeoData),
      tap(data => this.seoData = data),
      switchMap(() => forkJoin([
        this.activatedRoute.params.pipe(
          map(params => {
            if (!params.page) { return null; }
            return Number(params.page.replace('page', ''));
          }),
          take(1)),
        this.translocoService.selectTranslate('page').pipe(take(1)),
        this.titleForListPage.pipe(take(1)),
        this.preparatSeoData.pipe(take(1)),
      ])),
      takeUntil(this.componentDestroyer)
    ).subscribe(([pageNum, translate, tradeName, preparatSeo]: [number | null, string, string, IPreparatPageResponse]) => {
      if (this.platform.pathname.includes('category')) {
        const tempTitle: string = this.seoData.seo_title ? this.seoData.seo_title + ', ' : ''; // TODO: убрать, когда везде будут сео тайтлы
        const title = pageNum ? tempTitle + translate + pageNum : this.seoData.seo_title;
        const description = pageNum ? this.seoData.seo_description + ', ' + translate + pageNum : this.seoData.seo_description;
        this.seo.setStaticTitleWithOutTranslate(title);
        this.seo.setStaticDescriptionWithOutTranslate(description);
        this.setBreadcrambsSeoScript();
      }
      if (this.platform.pathname.includes('/list/') && tradeName) {
        const titlePageNum: string = getPageNumForTitle(this.p ? this.p.getCurrent() as number : 0, this.locale.getLang());
        if (this.seoData.seo_title) {
          const splitedTitle: string[] = this.seoData.seo_title.split(' ');
          splitedTitle.push(titlePageNum);
          this.seo.setStaticTitleWithOutTranslate(splitedTitle.join(' '));
        }
        if (this.seoData.seo_description) {
          this.seo.setStaticDescriptionWithOutTranslate(this.seoData.seo_description);
        }
        this.setFaqSeoScript();
        this.setBreadcrambsSeoScript();
      }
      if (this.platform.pathname.includes('/preparat/') && preparatSeo) {
        this.seo.setStaticTitleWithOutTranslate(this.seoData.seo_title);
        this.seo.setStaticDescriptionWithOutTranslate(this.seoData.seo_description);
        this.setFaqSeoScript(true);
        this.setBreadcrambsSeoScript();
      }
      if (
        this.platform.pathname.includes('search') &&
        !this.platform.pathname.includes('list') &&
        !this.platform.pathname.includes('category')
      ) {
        this.seo.setStaticTitle('start.page.meta.teg.title');
        this.seo.setStaticDescription('start.page.meta.teg.description');
      }
    });
  }

  public readMoreSeoText(): void {
    this.showFullSeoText = !this.showFullSeoText;
  }

  public togglePharmacy(pharmacy: IPreparatPharmacy): void {
    this.store.dispatch(TogglePreparatPharmacyProducts({ pharmacy }));
  }

  private getParamsRequest(): void {
    this.activatedRoute.queryParams.pipe(
      withLatestFrom(this.activatedRoute.params),
      take(1)
    ).subscribe(([params, searchParams]: [ParamsPageSearch, Params]) => {
      this.url = searchParams.url;
      if (this.helperDetectedPageService.isCategoryPage()) {
        this.params = {
          ...params,
          sectionId: '2',
          info: '3',
          pStart: '1',
          pEnd: '1'
        };
      } else {
        if (this.platform.pathname.includes('/list/')) {
          this.params = {
            ...params,
            sectionId: '1',
            info: 'trade',
            pattern: searchParams.url,
            tradeNameEn: 'true',
            pStart: '1',
            pEnd: '1'
          };
        } else if (this.platform.pathname.includes('/preparat/')) {
          this.url = 'by-town';
          this.params = {
            ...params,
            sectionId: '1',
            info: 'trade',
            pattern: searchParams.url,
            tradeNameEn: 'true',
            pStart: '1',
            pEnd: '1'
          };
        } else {
          this.params = params;
        }
      }
    });
  }

  private addedFiltersBlock(): void {
    this.lazy.addCoreLazyComponent(this.filters, ListLazyComponents.filter)
      .then((containerF: ComponentRef<any>) => {
        containerF.instance.container = this.filters;
        containerF.instance.containerRef = containerF;
        containerF.instance.data = this.store.pipe(select(selectFoundsFiltersPage));
        containerF.instance.activeFilters = this.store.pipe(select(activeFiltersPage));

        containerF.instance.onChangeFilter.pipe(
          debounceTime(10),
          takeUntil(this.componentDestroyer)
        ).subscribe((data: Map<string, Set<number>>) => {
          this.filtersList(data);
          this.cdr.detectChanges();
        });
      });
  }

  private filtersList(data: Map<string, Set<number>>): void {
    this.getParamsRequest();
    this.addFilterToParamsUrl(data);
  }

  private scrollPositionSearchPage(position: number, fromPaginator?: boolean): void {
    setTimeout(() => {
      if (this.screen.isDesktop()) {
        const productsBlock: Element = document.getElementsByClassName('search-result-products')[0];
        (productsBlock as HTMLElement)?.scroll({
          top: position,
          behavior: fromPaginator ? 'auto' : 'smooth'
        });
      } else {
        window.scroll({
          top: position,
          behavior: fromPaginator ? 'auto' : 'smooth'
        });
      }
    }, 200);
  }

  private setFaqSeoScript(isPreparatPage: boolean = false): void {
    if (this.isSearchTradeName || isPreparatPage) {
      let data$: Observable<ITradeGoodsResponse | IPreparatPageResponse>;
      if (this.isSearchTradeName) {
        data$ = this.seoFaqForTradeNameListPage;
      }
      if (isPreparatPage) {
        data$ = this.preparatSeoData;
      }
      data$.pipe(
        filter(x => !!x),
        filter(y => Boolean(y.faqs.length)),
        map((data) => data.faqs),
        take(1)
      ).subscribe((faqs: IFaqResponse[]) => {
        // добавление скрипта только на первую страницу, так как на следующих страницах пагинации блок с вопросами скрыт
        if (this.p?.getCurrent() === 1) {
          this.jsonLDService.add(
            JsonLDServiceService.FAQPage(
              JsonLDServiceService.mutationListFaqs(faqs)
            ),
            'structured-data-faq'
          );
        }
      });
    }
  }

  private setBreadcrambsSeoScript(): void {
    this.references.pipe(
      filter(value => !!value),
      take(1)
    ).subscribe((references: IToSearchWithCategory[]) => {
      const mappedReferences = references.map((item) => {
        let redirectTo: string = item.info !== '3' ? 'catalog' : 'category';
        if (item.info === 'trade') {
          redirectTo = 'list';
        }
        if (this.locale.getLang() === 'ru') {
          return {
            ...item,
            url: `https://zdorovi.ua/${redirectTo}/${item.url}`,
          };
        } else {
          return {
            ...item,
            url: `https://zdorovi.ua/ua/${redirectTo}/${item.url}`,
          };
        }
      });
      const result: IToSearchWithCategory[] = [
        {
          name: this.locale.getLang() === 'ru' ? 'Поиск лекарств' : 'Пошук ліків',
          url: this.locale.getLang() === 'ru' ? 'https://zdorovi.ua' : 'https://zdorovi.ua/ua',
        },
        ...mappedReferences,
      ];
      this.jsonLDService.add(
        JsonLDServiceService.Breadcrambs(JsonLDServiceService.mutationReferences(result)), 'structured-data-crumbs'
      );
    });
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('scroll', this.scroll, true);
      this.scrollPS.scrollPosition = this.scrollPosition ? this.scrollPosition.toFixed() : '0';

      this.store.dispatch(ResetPageStateAction());

      this.jsonLDService.remove();
    }

    this.componentDestroyer.next(null);
    this.componentDestroyer.complete();
  }
}
